export default __webpack_public_path__ + "static/media/thumc_article.dc004a00.svg";